import { parse } from 'date-fns';
import type { Schedule } from '../types/schedule.type';

export function parseSchedule(value: string, defaultValue: string): Schedule {

  try {

    const date = new Date();
    const schedule = JSON.parse(value) as Record<string, { startTime?: string; endTime?: string }>;
    const dates = {} as Schedule;
  
    for (const [key, times] of Object.entries(schedule)) {
      dates[key as keyof Schedule] = {
        startTime: times.startTime ? parse(times.startTime, 'h:mm a', date) : undefined,
        endTime: times.endTime ? parse(times.endTime, 'h:mm a', date) : undefined
      };
    }
  
    return dates;
  
  } catch (error) {

    console.error('Error parsing schedule:', error);

    return parseSchedule(defaultValue, defaultValue);
  }
}
